import { IGroup } from 'app/shared/model/group.model';

export interface IUserGroup {
  id?: number;
  enabled?: boolean;
  admin?: boolean;
  group?: IGroup | null;
}

export const defaultValue: Readonly<IUserGroup> = {
  enabled: false,
  admin: false,
};
